import { Modifiers } from 'utils/bem';
import { block as rootBlock } from '../utils';

export const block = (
  elementNameOrModifiers?: string | Modifiers,
  modifiers?: Modifiers,
) => {
  if (typeof elementNameOrModifiers === 'string') {
    return rootBlock(`landing-page-${elementNameOrModifiers}`, modifiers);
  }

  return rootBlock('landing-page', elementNameOrModifiers);
};
